/* Shop assistant — photo or sentence → catalogue ideas → wall preview → order, or
   on-demand creation with Atelier credits. Talks to the mural-assistant service (#as-config.api).

   Rules kept from the proven wall-preview integration:
   - one device account (localStorage), email asked only at the first paid action, consent shown;
   - every paid job has a client-generated id: a dropped connection is recovered by polling,
     never by re-posting a new job;
   - results link to real product URLs (SEO), nothing replaces a server-rendered page.
   Exposes window.MPPAssistant.preview({handle, cropUrl, title, thumb}) for the product page. */
(function () {
  'use strict';

  function i18n(ns) { var el = document.getElementById('mpp-i18n'), o = {}, out = {}, d = document.createElement('textarea'); try { o = JSON.parse(el.textContent)[ns] || {}; } catch (e) {} Object.keys(o).forEach(function (k) { d.innerHTML = o[k]; out[k] = d.value; }); return out; }
  function readJSON(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var CFG = readJSON('as-config');
  if (!CFG || !CFG.api) return;
  var API = CFG.api.replace(/\/+$/, '');
  var LS = 'mpp_assistant_v1';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,24}$/i;
  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }

  /* ---------- language, currency, storefront root ---------- */
  var LOCALE = document.documentElement.lang || 'fr';
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || CFG.currency || 'EUR';
  var RATE = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);   // shop currency → active currency
  var money;
  try { money = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR }); } catch (e) { money = new Intl.NumberFormat(undefined, { style: 'currency', currency: CFG.currency || CUR }); }
  // prices from the assistant API are in the shop currency: shown converted at once (an approximate « dès »
  // price), then replaced by the product's own price in the visitor's currency (market adjustments and
  // rounding included). Liquid prices from the config (credits, sample) are already in the active currency.
  var FOREIGN = !!(CFG.shopCurrency && CUR !== CFG.shopCurrency) || (RATE > 0 && RATE !== 1);
  function shopPrice(v) { return money.format(RATE > 0 && RATE !== 1 ? v * RATE : v); }
  var localPrices = {};   // handle → price_min (cents, active currency)
  function localizePrices(items) {
    if (!FOREIGN) return;
    items.forEach(function (it) {
      if (!it || !it.handle || it.creation || it.status === 'DRAFT' || !it.url) return;
      var apply = function () {
        $$('.as-card[data-handle="' + CSS.escape(it.handle) + '"] .as-meta').forEach(function (el) {
          var kind = kindOf(it.title) || CFG.collections[it.collection] || '';
          el.textContent = kind + (kind ? ' · ' : '') + L('price_from', { price: money.format(localPrices[it.handle] / 100) });
        });
      };
      if (has(localPrices, it.handle)) return apply();
      fetch(loc(it.url) + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) { if (Number.isInteger(p.price_min)) { localPrices[it.handle] = p.price_min; apply(); } })
        .catch(function () {});
    });
  }
  function priceFrom(it) { return has(localPrices, it.handle) ? money.format(localPrices[it.handle] / 100) : shopPrice(it.price_from); }
  var ROOT = (CFG.root || '/').replace(/\/$/, '');
  // a root-relative storefront path keeps the visitor in their language (/en/products/…); absolute or already-prefixed URLs are left alone
  function loc(u) {
    if (!ROOT || typeof u !== 'string' || u.charAt(0) !== '/' || u.charAt(1) === '/' || u === ROOT || u.indexOf(ROOT + '/') === 0) return u;
    return ROOT + u;
  }
  function creationHref(id) { return CFG.creationUrl ? loc(CFG.creationUrl) + '?creation=' + encodeURIComponent(id) : ''; }

  /* ---------- copy (locale keys js.assistant.*, rendered by the layout in #mpp-i18n) ---------- */
  var T = i18n('assistant');
  // L(key, {n: 3}) → the text with its {placeholders} filled; a missing key shows its own name, never « undefined »
  function L(k, v) {
    var s = has(T, k) ? T[k] : k;
    return v ? s.replace(/\{(\w+)\}/g, function (m, n) { return has(v, n) ? String(v[n]) : m; }) : s;
  }
  var PR = null;
  try { PR = new Intl.PluralRules(LOCALE); } catch (e) {}
  // P('credit', n) → credit_one / credit_other with {n}
  function P(k, n) { return L(k + ((PR ? PR.select(n) === 'one' : n <= 1) ? '_one' : '_other'), { n: n }); }
  var REFINE = ['lighter', 'darker', 'more_vegetal', 'more_colour', 'softer', 'more_graphic', 'calmer'];   // ids sent to the API
  var ROOMS = { salon: 'living_room', chambre: 'bedroom', 'chambre-enfant': 'kids_room', 'chambre-bebe': 'nursery', cuisine: 'kitchen',
    'salle-a-manger': 'dining_room', bureau: 'office', entree: 'entrance', 'salle-de-bain': 'bathroom', couloir: 'hallway' };   // API room id → copy key

  var S = { account: null, quota: null, costs: null, photo: null, text: '', understood: null, items: [], shown: [], refine: null, creations: [], view: null, busy: false };
  try { var saved = JSON.parse(localStorage.getItem(LS) || '{}'); S.account = saved.account || null; } catch (e) {}
  function save() { try { localStorage.setItem(LS, JSON.stringify({ account: S.account })); } catch (e) {} }

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16); crypto.getRandomValues(b); b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function errText(code) {
    if (!code) return L('err');
    if (code.indexOf('refused') === 0) return L('error_refused');
    return has(T, 'error_' + code) ? T['error_' + code] : L('err');   // error_rate_limited, error_busy… (codes from the API)
  }
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_SWAP = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 7l-5 5 5 5M15 7l5 5-5 5"/></svg>';

  /* ---------- API ---------- */
  // what each paid action costs and how many previews are free: the service's config (/v1/session and /v1/me
  // « costs », the older quota.costs as fallback) — never written in the copy
  function setCosts(d) { var c = (d && d.costs) || (d && d.quota && d.quota.costs); if (c) S.costs = c; }
  function cost(k) { var c = S.costs || (S.quota && S.quota.costs) || {}; return typeof c[k] === 'number' ? c[k] : null; }
  function costText(k) { var n = cost(k); return n == null ? '' : P('credit', n); }
  // run fn once the costs are known: at once, or after the session / account answer (a sheet opened before
  // any session fills its cost lines a moment later)
  function withCosts(fn) {
    if (cost('create') != null) return fn();
    ensureAccount().then(function () { if (cost('create') == null) return refreshMe(); }).then(fn).catch(function () {});
  }
  function ensureAccount() {
    if (S.account) return Promise.resolve();
    return fetch(API + '/v1/session', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ locale: CFG.lang }) })
      .then(function (r) { if (!r.ok) throw new Error('session'); return r.json(); })
      .then(function (d) { S.account = d.account; S.quota = d.quota; S.features = d.features || {}; setCosts(d); save(); renderWallet(); });
  }
  function api(path, opts) {
    opts = opts || {};
    var go = function () {
      var h = { 'Content-Type': 'application/json' };
      if (opts.auth) h.Authorization = 'Bearer ' + S.account;
      return fetch(API + path, { method: opts.body ? 'POST' : 'GET', headers: h, body: opts.body ? JSON.stringify(opts.body) : undefined })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (d) { return { status: r.status, data: d }; }); });
    };
    var p = opts.auth ? ensureAccount().then(go) : go();
    return p.then(function (res) {
      if (res.status === 401 && opts.auth && !opts.retried) { S.account = null; save(); opts.retried = true; return api(path, opts); }
      return res;
    });
  }
  function refreshMe() {
    if (!S.account) return Promise.resolve();
    return api('/v1/me', { auth: true }).then(function (r) {
      if (r.status === 200) { S.quota = r.data.quota; S.features = r.data.features || S.features || {}; setCosts(r.data); S.creations = r.data.creations || []; renderWallet(); }
    }).catch(function () {});
  }

  /* ---------- header wallet + toast ---------- */
  function renderWallet() {
    var host = $('.top-right'); if (!host) return;
    var w = $('#asWallet');
    if (!S.quota || !S.quota.email) { if (w) w.hidden = true; return; }
    if (!w) {
      w = document.createElement('button'); w.type = 'button'; w.id = 'asWallet'; w.className = 'as-wallet';
      w.addEventListener('click', function () { creditsSheet(null); });
      host.insertBefore(w, host.firstChild);
    }
    w.hidden = false;
    var q = S.quota;
    w.innerHTML = (q.free_previews > 0 ? P('free_preview', q.free_previews) : L('wallet_none')) + '<span class="as-wl-long"> · ' + P('credit', q.credits) + '</span>';
  }
  var toastTimer;
  function toast(msg, label, fn) {
    var host = $('#asToast'); if (!host) return;
    host.innerHTML = '<div class="as-toast" role="status"><span>' + esc(msg) + '</span>' + (label ? '<button type="button">' + esc(label) + '</button>' : '') + '</div>';
    var b = $('button', host); if (b) b.onclick = function () { host.innerHTML = ''; fn(); };
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { host.innerHTML = ''; }, label ? 9000 : 4200);
  }

  /* ---------- photo ---------- */
  function toCanvas(src, max) {
    var w = src.width || src.naturalWidth, h = src.height || src.naturalHeight, k = Math.min(1, max / Math.max(w, h));
    var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
    c.getContext('2d').drawImage(src, 0, 0, c.width, c.height); return c;
  }
  function decode(blob) {
    if (window.createImageBitmap) {
      return createImageBitmap(blob, { imageOrientation: 'from-image' }).catch(function () { return createImageBitmap(blob); });
    }
    return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = URL.createObjectURL(blob); });
  }
  function setPhoto(blob, isSample) {
    return decode(blob).then(function (bmp) {
      S.photo = { big: toCanvas(bmp, 1600).toDataURL('image/jpeg', 0.86), small: toCanvas(bmp, 1024).toDataURL('image/jpeg', 0.82), sample: !!isSample };
      var z = $('#asZone'); if (!z) return;
      z.classList.add('has-photo'); $('#asZoneEmpty').hidden = true;
      $$('img, .as-change', z).forEach(function (n) { n.remove(); });
      z.insertAdjacentHTML('beforeend', '<img src="' + S.photo.small + '" alt=""><label class="as-btn as-ghost as-sm as-change" for="asPhoto">' + L('change_photo') + '</label>');
    }).catch(function () { toast(L('error_bad_photo')); throw new Error('photo'); });
  }
  function sampleBlob() { return fetch(CFG.sampleRoom).then(function (r) { if (!r.ok) throw new Error('sample'); return r.blob(); }); }

  /* ---------- analysis & results ---------- */
  function start(append) {
    var ta = $('#asText');
    S.text = ta ? ta.value.trim() : S.text;
    if (!S.photo && !S.text) {
      var e = $('#asEntry'); if (e) { e.classList.remove('as-shake'); void e.offsetWidth; e.classList.add('as-shake'); }
      toast(L('need_input')); return;
    }
    if (S.busy) return; S.busy = true;
    var an = $('#asAnalysis'), res = $('#asResults');
    if (!append) {
      S.shown = []; S.items = [];
      an.hidden = false;
      an.innerHTML = '<div class="as-an">' + (S.photo ? '<img src="' + S.photo.small + '" alt="">' : '') + '<div class="as-an-body"><div class="as-an-title"><span class="as-dots">' +
        (S.photo ? L('look_room') : L('look_text')) + '</span></div><div class="as-chips"></div></div></div>';
      res.hidden = false;
      res.innerHTML = '<div class="as-grid">' + new Array(6).join('<div class="as-skel"></div>') + '</div>';
      an.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
    }
    // the first answer carries ctx (what was understood): refinements, « more » and « similar » reuse it,
    // so a photo is analysed once
    var fresh = !append && !S.refine && !S.similar;
    if (fresh) S.ctx = null;
    // « more ideas » first serves the candidates the room rerank kept in reserve
    if (append && S.reserve && S.reserve.length) {
      S.busy = false;
      S.items = S.items.concat(S.reserve.splice(0, 12));
      renderResults(true);
      return Promise.resolve();
    }
    if (!append) S.reserve = [];
    // a room photo asks for 24 candidates: Claude chooses among them, the best 12 are shown
    var pool = fresh && S.photo ? 24 : 12;
    var body = { lang: CFG.lang, limit: pool, exclude: append ? S.shown : [] };
    if (S.ctx) body.ctx = S.ctx; else { body.text = S.text; body.photo = S.photo ? S.photo.small : null; }
    if (S.refine) body.refine = [S.refine];
    if (S.similar) body.similar = S.similar.handle;
    return api('/v1/recommend', { body: body })
      .then(function (r) {
        S.busy = false;
        if (r.status !== 200) throw new Error(r.data.error || 'http');
        S.ctx = r.data.ctx || S.ctx;
        if (!append) { S.understood = r.data.understood || {}; renderAnalysis(); }
        r.data.items.forEach(function (it) { if (S.shown.indexOf(it.handle) < 0) { S.shown.push(it.handle); S.items.push(it); } });
        if (pool > 12) S.reserve = S.items.splice(12);
        renderResults(append);
        if (!append && S.items.length) {
          if (S.photo && S.ctx && S.ctx.photo && !S.similar) chooseForRoom(); else loadReasons(S.items.slice(0, 3));
        }
      })
      .catch(function (err) {
        S.busy = false;
        var msg = errText(err && err.message);
        res.hidden = false;
        res.innerHTML = '<div class="as-empty"><p>' + esc(msg) + '</p><button type="button" class="as-btn as-ghost" data-as="retry">' + L('retry') + '</button></div>';
        if (!append) an.hidden = true;
      });
  }
  function renderAnalysis() {
    var u = S.understood || {}, an = $('#asAnalysis');
    $('.as-an-title', an).textContent = L('seen');
    var sw = (u.colours || []).slice(0, 5).map(function (c, i) { return '<i style="background:' + esc(c.hex) + ';animation-delay:' + (i * 70) + 'ms" title="' + esc(c.name) + '"></i>'; }).join('');
    var labels = (u.labels || []).slice(0, 4);
    if (S.text && !S.photo && !labels.length) labels = [L('quoted', { t: S.text.length > 32 ? S.text.slice(0, 30) + '…' : S.text })];
    $('.as-chips', an).innerHTML = (sw ? '<span class="as-swatches"><small>' + L('colours') + '</small>' + sw + '</span>' : '') +
      labels.map(function (l, i) { return '<span class="as-tag" style="animation-delay:' + (200 + i * 90) + 'ms">' + esc(l) + '</span>'; }).join('');
  }
  function title() {
    var n = S.items.length, u = S.understood || {};
    if (u.room && has(ROOMS, u.room)) return L('ideas_' + ROOMS[u.room], { n: n });   // ideas_living_room, ideas_bedroom…
    if (!S.photo && S.text) return L('ideas_text', { n: n, text: esc(S.text.length > 40 ? S.text.slice(0, 38) + '…' : S.text) });
    return L('ideas_match', { n: n });
  }
  function nameOf(title) { var p = String(title || '').split(' | '); return p.length > 1 ? p.slice(1).join(' | ') : p[0]; }
  function kindOf(title) { var p = String(title || '').split(' | '); return p.length > 1 ? p[0] : ''; }
  function card(it, i, mine) {
    var kind = kindOf(it.title) || CFG.collections[it.collection] || '';
    var price = mine ? '' : '<p class="as-meta">' + esc(kind) + (kind ? ' · ' : '') + L('price_from', { price: priceFrom(it) }) + '</p>';
    var badge = mine ? '<span class="as-badge is-mine">' + L('mine') + '</span>' : (i === 0 && S.photo ? '<span class="as-badge">' + L('best') + '</span>' : '');
    /* every catalogue card leads to its product page (« Commander »). A design still in draft has no
       public page yet: the same link opens the quick view and says it is coming, and it turns into the
       real link by itself once the product is activated (the index refreshes every 15 min). */
    var draft = !mine && it.status === 'DRAFT';
    var href = mine ? creationHref(it.creation) : loc(it.url);
    var link = function (inner, cls) {
      if (!href) return '<span class="' + cls + '">' + inner + '</span>';
      return '<a class="' + cls + '" href="' + esc(href) + '"' + (draft ? ' data-as="quick"' : '') + '>' + inner + '</a>';
    };
    return '<article class="as-card" data-handle="' + esc(it.handle || '') + '" data-creation="' + esc(it.creation || '') + '" data-view="room" style="animation-delay:' + (Math.max(0, i) * 45) + 'ms">' +
      '<div class="as-card-media">' + link('<img src="' + esc(it.room_image || it.room) + '" alt="' + esc(it.title) + '" decoding="async"><img class="as-flat" src="' + esc(it.design_image || it.design) + '" alt="" decoding="async">', 'as-card-img') + badge +
      '<div class="as-seg"><button type="button" data-as="view" data-v="room" aria-pressed="true">' + L('in_room') + '</button><button type="button" data-as="view" data-v="flat" aria-pressed="false">' + L('flat') + '</button></div></div>' +
      '<div class="as-card-body"><h3>' + link(esc(nameOf(it.title)), '') + '</h3>' + price + '<p class="as-why" hidden></p>' +
      '<div class="as-card-actions"><button type="button" class="as-btn as-primary as-sm" data-as="preview">' + L('see_wall') + '</button>' +
      (href ? '<a class="as-btn as-ghost as-sm" href="' + esc(href) + '"' + (draft ? ' data-as="order-draft"' : '') + '>' + L('order') + '</a>' : '') + '</div>' +
      (mine ? '' : '<div class="as-card-links"><button type="button" class="as-link" data-as="quick">' + L('quick') + '</button><button type="button" class="as-link as-similar" data-as="similar">' + L('similar_btn') + '</button></div>') + '</div></article>';
  }
  function renderResults(append) {
    var res = $('#asResults'); res.hidden = false;
    if (!S.items.length && !S.creations.length) {
      res.innerHTML = '<div class="as-empty"><span class="as-eyebrow">' + L('empty_kicker') + '</span><h3>' + L('empty_title') + '</h3><button type="button" class="as-btn as-primary" data-as="create">' + L('create_btn') + '</button></div>';
      return;
    }
    var mine = S.creations.slice(0, 2).map(function (c) { return card(c, -1, true); }).join('');
    var cards = S.items.map(function (it, i) { return card(it, i, false); }).join('');
    var createCard = '<article class="as-card as-create"><div style="display:grid;gap:10px"><span class="as-eyebrow">' + L('nothing') + '</span><h3>' + L('create_one') + '</h3><p>' + L('create_sub') + '</p></div>' +
      '<button type="button" class="as-btn as-primary as-block" data-as="create">' + L('create_btn') + '</button></article>';
    var head = S.similar ? L('similar_head', { t: esc(nameOf(S.similar.title)) }) : title();
    var sub = S.similar ? '<button type="button" class="as-link" data-as="unsimilar">' + L('back_ideas') + '</button>' : L('from_catalog');
    res.innerHTML = '<div class="as-res-head"><div><h2>' + head + '</h2><p>' + sub + '</p></div><div class="as-chips" role="group" aria-label="' + esc(L('refine_label')) + '">' +
      REFINE.map(function (r) { return '<button type="button" class="as-chip" data-as="refine" data-r="' + esc(r) + '" aria-pressed="' + (S.refine === r) + '">' + L('refine_' + r) + '</button>'; }).join('') +
      '</div></div><div class="as-grid">' + mine + cards + createCard + '</div>' +
      '<div class="as-more"><button type="button" class="as-btn as-ghost" data-as="more">' + L('more') + '</button></div>' + helpHTML();
    if (!append && !S.scrolled) { S.scrolled = true; }
    localizePrices(S.items);
  }
  function helpHTML() {
    var sample = CFG.sample ? '<div class="as-help-card"><div class="as-help-ico"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><rect x="6" y="3" width="12" height="18" rx="1.5"/><path d="M9 8h6M9 12h6M9 16h3" stroke-linecap="round"/></svg></div><div><h3>' + L('sample_title') + '</h3><p>' + L('sample_lead', { price: money.format(CFG.sample.price / 100), format_name: esc(CFG.sampleFormat || '') }) + '</p></div></div>' : '';
    return '<div class="as-help">' + sample + '<div class="as-help-card"><div class="as-help-ico"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M3 20V9l9-5 9 5v11"/><path d="M8 20v-6h8v6"/></svg></div>' +
      '<div><h3>' + L('ct_title') + '</h3><p>' + L('ct_lead') + '</p></div><button type="button" class="as-btn as-ghost as-sm" data-as="contact">' + L('ct_write') + '</button></div></div>';
  }
  /* room photo: Claude looks at the room and the candidates together and chooses; the grid then
     re-orders itself (cards keep their element, so nothing reloads) and the top reasons appear */
  function chooseForRoom() {
    var all = S.items.concat(S.reserve || []);
    var ctx = S.ctx;
    api('/v1/rerank', { body: { photo: S.photo.small, ctx: ctx, handles: all.map(function (i) { return i.handle; }), lang: CFG.lang } }).then(function (r) {
      if (r.status !== 200 || S.ctx !== ctx || !r.data.order) return;
      var pos = {}; r.data.order.forEach(function (h, i) { pos[h] = i; });
      all.sort(function (a, b) { return (pos[a.handle] == null ? 99 : pos[a.handle]) - (pos[b.handle] == null ? 99 : pos[b.handle]); });
      S.items = all.slice(0, 12); S.reserve = all.slice(12);
      renderResults(false);
      var reasons = r.data.reasons || {};
      Object.keys(reasons).forEach(function (h) {
        var el = $('.as-card[data-handle="' + CSS.escape(h) + '"] .as-why');
        if (el && reasons[h]) { el.textContent = reasons[h]; el.hidden = false; }
      });
    }).catch(function () { loadReasons(S.items.slice(0, 3)); });
  }

  function loadReasons(items) {
    if (!S.understood || (!S.photo && !S.text)) return;
    api('/v1/reasons', { body: { room: S.understood, wish: S.text, handles: items.map(function (i) { return i.handle; }), lang: CFG.lang } })
      .then(function (r) {
        var reasons = (r.data && r.data.reasons) || {};
        Object.keys(reasons).forEach(function (h) {
          var el = $('.as-card[data-handle="' + CSS.escape(h) + '"] .as-why');
          if (el && reasons[h]) { el.textContent = reasons[h]; el.hidden = false; }
        });
      }).catch(function () {});
  }

  /* ---------- sheet ---------- */
  var lastFocus = null;
  function openSheet(html, cls, view) {
    var s = $('#asSheet'); $('#asBody').innerHTML = html;
    $('#asPanel').className = 'as-panel' + (cls ? ' ' + cls : '');
    var h = $('#asBody h2'); if (h) h.id = 'asSheetTitle';
    if (s.hidden) { lastFocus = document.activeElement; s.hidden = false; document.documentElement.classList.add('as-lock'); }
    S.view = view || null; $('#asPanel').scrollTop = 0;
    var f = $('#asBody [autofocus]') || $('.as-close', s); if (f) f.focus({ preventScroll: true });
  }
  function closeSheet() {
    var s = $('#asSheet'); if (!s || s.hidden) return;
    s.hidden = true; document.documentElement.classList.remove('as-lock'); S.view = null;
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  /* ---------- jobs ---------- */
  function runJob(path, body, kind, heading, img, steps, expectMs, hint) {
    var started = Date.now(), done = false;
    var stepHTML = steps.map(function (s) { return '<li><i></i>' + esc(s) + '</li>'; }).join('');
    var show = function () {
      openSheet('<div class="as-prog"><div class="as-prog-art">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</div><h2>' + esc(heading) + '</h2><ol class="as-steps">' + stepHTML +
        '</ol><div class="as-bar"><i id="asBar"></i></div><p class="as-fine">' + esc(hint) + '</p></div>', '', 'job:' + body.job_id);
    };
    show();
    var tick = setInterval(function () {
      if (S.view !== 'job:' + body.job_id) return;
      var p = Math.min(0.95, (Date.now() - started) / expectMs);
      var bar = $('#asBar'); if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
      $$('.as-steps li').forEach(function (li, i) {
        var a = i / steps.length, b = (i + 1) / steps.length;
        li.className = p >= b ? 'is-done' : p >= a ? 'is-on' : '';
        if (p >= b && !li.dataset.ok) { li.dataset.ok = 1; $('i', li).innerHTML = ICON_CHECK; }
      });
    }, 400);
    var poll = function () {
      return wait(4000).then(function () { return api('/v1/jobs/' + body.job_id, { auth: true }); }).then(function (r) {
        if (r.status === 200 && r.data.state !== 'running') return r;
        if (Date.now() - started > 9 * 60 * 1000) return { status: 504, data: { state: 'failed', error: 'timeout' } };
        return poll();
      }, function () { return poll(); });
    };
    return api(path, { auth: true, body: body })
      .then(function (r) { return (r.status >= 500 || (r.status === 200 && r.data.state === 'running')) ? poll() : r; }, function () { return poll(); })
      .then(function (r) {
        clearInterval(tick); done = true;
        return refreshMe().then(function () { return { r: r, visible: S.view === 'job:' + body.job_id, kind: kind }; });
      });
  }
  function finish(out, onOk, onRetry) {
    var r = out.r, d = r.data || {};
    if (r.status === 402 || d.error === 'payment_required') { return creditsSheet(onRetry, needText(out.kind, d.need)); }
    if (d.error === 'email_required') return emailGate(onRetry, out.kind);
    if (d.state !== 'succeeded') {
      if (out.visible) openSheet('<h2>' + esc(errText(d.error)) + '</h2><div class="as-actions"><button type="button" class="as-btn as-primary" data-as="close">' + L('ok') + '</button></div>', '', 'error');
      else toast(errText(d.error));
      return;
    }
    if (out.visible) onOk(d);
    else {
      var pill = document.createElement('button'); pill.type = 'button'; pill.className = 'as-ready';
      pill.textContent = out.kind === 'preview' ? L('ready_pv') : L('ready_cr');
      var host = $('.top-right'); if (host) host.insertBefore(pill, host.firstChild);
      var open = function () { pill.remove(); onOk(d); };
      pill.onclick = open; toast(pill.textContent, L('see'), open);
    }
  }

  // « Creating a design costs 2 credits. » — the cost from the service (its 402 answer's need, else its config)
  function needText(kind, need) {
    var k = kind === 'preview' ? 'preview' : kind === 'retouch' ? 'retouch' : 'create';
    return L('need_' + k, { cost: typeof need === 'number' ? P('credit', need) : costText(k) });
  }

  /* ---------- wall preview ---------- */
  function preview(o) {
    if (o.title && !o.short) { o.title = nameOf(o.title); o.short = true; }
    if (o.choices && !o.choice) return chooseProjection(o);
    if (!S.photo) return askPhoto(function () { preview(o); });
    return ensureAccount().then(function () {
      if (!S.quota || !S.quota.email) return emailGate(function () { preview(o); });
      var q = S.quota;
      var need = cost('preview') || 0;    // unknown cost: the service decides (402 → credits sheet)
      if (q.free_previews <= 0 && q.credits < need && !o.fresh) return refreshMe().then(function () { o.fresh = true; return preview(o); });
      if (q.free_previews <= 0 && q.credits < need) return creditsSheet(function () { preview(o); }, needText('preview'));
      var body = { job_id: uuid(), photo: S.photo.big, lang: CFG.lang };
      if (o.creation) body.creation = o.creation; else body.handle = o.handle;
      return Promise.all([o.framedPromise || Promise.resolve(null), o.cropPromise || Promise.resolve(o.cropUrl)]).then(function (got) {
        if (got[0]) body.design_image = got[0];      // the framing rendered in the browser (product page)
        else if (got[1]) body.crop_url = got[1];
        return runJob('/v1/preview', body, 'preview', L('pv_heading', { t: o.title || '' }), o.thumb, [L('pv_step_1'), L('pv_step_2'), L('pv_step_3')], 45000, L('pv_hint'));
      }).then(function (out) { finish(out, function (d) { showPreview(o, d); }, function () { preview(o); }); });
    }).catch(function () { toast(L('err')); });
  }
  /* From the product page: project the customer's framing (with its effect / whole-design option)
     or the complete design as drawn. */
  function chooseProjection(o) {
    var c = o.choices;
    var framedStyle = '';
    var card = function (key, item, style) {
      return '<button type="button" class="as-choice" data-choice="' + key + '"' + (item.disabled ? ' disabled' : '') + '><span class="as-choice-media"><img src="' + esc(item.thumb) + '" alt="" style="' + (style || '') + '"></span>' +
        '<span class="as-choice-text"><b>' + esc(item.title) + '</b><small>' + esc(item.disabled ? item.why : item.sub) + '</small></span></button>';
    };
    openSheet('<span class="as-eyebrow">' + L('email_kicker') + '</span><h2>' + L('choice_title') + '</h2>' +
      '<div class="as-choices">' + card('framed', c.framed, framedStyle) + card('whole', c.whole, '') + '</div>' +
      '<p class="as-fine" id="asChoiceFine"></p>', 'is-mid', 'choice');
    withCosts(function () { var f = $('#asChoiceFine'); if (f && cost('preview') != null) f.textContent = L('choice_fine', { cost: costText('preview') }); });
    $$('.as-choice').forEach(function (b) {
      b.addEventListener('click', function () {
        o.choice = b.dataset.choice;
        if (o.choice === 'whole') { o.framedPromise = null; o.cropPromise = null; o.cropUrl = null; o.thumb = c.whole.thumb; }
        else o.thumb = c.framed.thumb;
        preview(o);
      });
    });
  }

  function showPreview(o, d) {
    var q = S.quota || {};
    var left = q.free_previews > 0 ? P('left_free', q.free_previews) : P('left_credit', q.credits || 0);
    var href = o.creation ? creationHref(o.creation) : loc(o.url || '');
    openSheet('<div class="as-ba is-intro" id="asBa" style="--x:100%"><img src="' + S.photo.big + '" alt="' + esc(L('before')) + '"><img class="as-after" src="' + esc(d.result.image) + '" alt="' + esc(L('with_title', { t: o.title == null ? '' : o.title })) + '">' +
      '<div class="as-ba-line"></div><div class="as-ba-knob">' + ICON_SWAP + '</div><span class="as-ba-tag is-l">' + L('before') + '</span><span class="as-ba-tag is-r">' + L('with_title', { t: esc(o.title) }) + '</span>' +
      '<input type="range" min="0" max="100" value="50" id="asBaR" aria-label="' + esc(L('compare_label')) + '"></div>' +
      '<div class="as-pv-info"><h2>' + esc(o.title) + '</h2><span class="as-fine">' + esc(left) + '</span></div>' +
      '<div class="as-actions">' + (href ? '<a class="as-btn as-primary" href="' + esc(href) + '">' + L('order_dims') + '</a>' : '<p class="as-note">' + L('order_soon') + '</p>') +
      '<button type="button" class="as-btn as-ghost" data-as="others">' + L('other') + '</button></div><p class="as-note">' + L('ai_note') + '</p>', 'is-mid', 'preview');
    var ba = $('#asBa'), r = $('#asBaR');
    var set = function (v) { ba.style.setProperty('--x', v + '%'); };
    if (REDUCED) { ba.classList.remove('is-intro'); set(50); }
    else { requestAnimationFrame(function () { requestAnimationFrame(function () { set(50); }); }); setTimeout(function () { ba.classList.remove('is-intro'); }, 1200); }
    r.oninput = function () { ba.classList.remove('is-intro'); set(r.value); };
  }
  function askPhoto(after) {
    S.afterPhoto = after;
    openSheet('<h2>' + L('photo_title') + '</h2><p class="as-lead2">' + L('photo_lead') + '</p><div class="as-actions"><label class="as-btn as-primary" for="asPhoto2">' + L('choose_photo') + '</label>' +
      '<button type="button" class="as-btn as-ghost" data-as="usesample">' + L('use_sample') + '</button></div><input type="file" id="asPhoto2" accept="image/*" class="as-sr">', '', 'photo');
    $('#asPhoto2').onchange = function (e) { var f = e.target.files[0]; if (f) setPhoto(f).then(continueAfterPhoto); };
  }
  function continueAfterPhoto() { var f = S.afterPhoto; S.afterPhoto = null; if (f) f(); }
  var PRIVACY_HREF = '/policies/privacy-policy';
  // kind = what the email is asked for (preview by default, create / retouch, credits): its own kicker, title and lead
  function emailGate(after, kind) {
    var k = (kind === 'create' || kind === 'retouch') ? '_create' : kind === 'credits' ? '_credits' : '';
    var free = (S.quota && S.quota.free_previews != null) ? S.quota.free_previews : (cost('free_previews') || 0);
    openSheet('<span class="as-eyebrow">' + L('email_kicker' + k) + '</span><h2>' + L('email_title' + k) + '</h2><p class="as-lead2">' + L('email_lead' + k) + '</p>' +
      '<div class="as-perks">' + (free > 0 ? '<span class="as-perk">' + P('free_preview', free) + '</span>' : '') + '<span class="as-perk">' + L('no_password') + '</span></div>' +
      '<form class="as-field" id="asEmailForm" novalidate><label for="asEm">' + L('email_label') + '</label><div class="as-row"><input class="as-input" id="asEm" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(L('email_ph')) + '" autofocus>' +
      '<button class="as-btn as-primary" type="submit">' + L('email_go') + '</button></div><p class="as-err" id="asEmErr" hidden>' + L('email_bad') + '</p>' +
      // the marketing consent is a separate, UNTICKED box (RGPD art. 7 §4): the email alone gives the free previews, the box only the emails
      '<label class="as-check as-check-mk" for="asMk"><input type="checkbox" id="asMk" autocomplete="off"><span>' + L('marketing') + '</span></label></form>' +
      '<p class="as-consent" id="asMkNote">' + L('consent') + ' <a href="' + esc(loc(CFG.privacyUrl || PRIVACY_HREF)) + '" target="_blank" rel="noopener">' + L('consent_privacy') + '</a></p>', '', 'email');
    $('#asEmailForm').onsubmit = function (e) {
      e.preventDefault();
      var v = $('#asEm').value.trim();
      if (!EMAIL_RE.test(v)) { $('#asEm').classList.add('is-bad'); $('#asEmErr').hidden = false; $('#asEm').focus(); return; }
      var btn = $('#asEmailForm button'); btn.disabled = true;
      // the service records a consent only for an explicit true, with the wording the page showed (box + note, as displayed)
      var mk = $('#asMk').checked, shown = $('#asMk').closest('label').textContent + ' ' + $('#asMkNote').textContent;
      api('/v1/identify', { auth: true, body: { email: v, locale: CFG.lang, marketing: mk, marketing_text: shown.replace(/\s+/g, ' ').trim() } }).then(function (r) {
        btn.disabled = false;
        if (r.status !== 200) { $('#asEmErr').textContent = errText(r.data.error); $('#asEmErr').hidden = false; return; }
        S.quota = r.data.quota; setCosts(r.data); renderWallet(); after();
      }, function () { btn.disabled = false; toast(L('err')); });
    };
  }

  /* ---------- credits ---------- */
  // CGV (Shopify policy « Terms of sale »): no anchor, Shopify's policy editor can drop ids — the link text says « article 12 »
  var TERMS_HREF = '/policies/terms-of-sale';
  function dateText(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    try { return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return d.toISOString().slice(0, 10); }
  }
  // the service names the expiry DAY (« 2027-11-15 », the shop's calendar, the last day the credits work): shown as that day
  // whatever the visitor's time zone; the instant (credits_expire_at) is only the fallback of an older service
  function dayText(ymd, iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || '');
    if (!m) return iso ? dateText(iso) : '';
    var d = new Date(+m[1], +m[2] - 1, +m[3]);
    try { return d.toLocaleDateString(LOCALE, { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return ymd; }
  }
  // « Votre solde : 12 crédits, valable jusqu'au … » — the service computes the day (12 months after the last purchase);
  // then what the customer should know: a payment being checked, credits that just expired
  function balanceLine() {
    var q = S.quota || {}, when = q.credits > 0 ? dayText(q.credits_expire_on, q.credits_expire_at) : '', out = '';
    if (when) out += '<p class="as-fine as-balance">' + esc(L('balance_until', { credits: P('credit', q.credits), date: when })) + '</p>';
    if (q.credits_held > 0) out += '<p class="as-note as-held" role="status">' + esc(L('held_note')) + '</p>';
    if (q.credits_expired_last && q.credits_expired_last.credits > 0) {
      out += '<p class="as-note as-expired">' + esc(L('expired_note', { credits: P('credit', q.credits_expired_last.credits), date: dayText(q.credits_expired_last.on) })) + '</p>';
    }
    return out;
  }
  function creditsSheet(after, reason) {
    var packs = (CFG.credits || []).filter(function (p) { return p.credits > 0; });
    var best = packs.length > 1 ? packs[1].id : (packs[0] && packs[0].id);
    var packHTML = packs.map(function (p) {
      return '<label class="as-pack"><input type="radio" name="asPack" value="' + p.id + '" data-price="' + p.price + '"' + (p.id === best ? ' checked' : '') + '>' + (p.id === best && packs.length > 1 ? '<em>' + L('recommended') + '</em>' : '') +
        '<b>' + p.credits + '</b><span class="as-p">' + money.format(p.price / 100) + '</span><small>' + L('price_per_credit', { price: money.format(p.price / 100 / p.credits) }) + '</small></label>';
    }).join('');
    var costRows = function () {
      return [['create', 'cd_create'], ['retouch', 'cd_retouch'], ['preview', 'cd_preview']].filter(function (r) { return cost(r[0]) != null; })
        .map(function (r) { return '<div><b>' + costText(r[0]) + '</b>' + L(r[1]) + '</div>'; }).join('');
    };
    openSheet('<span class="as-eyebrow">' + L('cd_kicker') + '</span><h2>' + (reason ? L('cd_need') : L('cd_title')) + '</h2><p class="as-lead2">' + esc(reason || L('cd_lead')) + '</p>' + balanceLine() +
      '<div class="as-costs" id="asCosts">' + costRows() + '</div>' +
      (packs.length ? '<div class="as-packs" role="radiogroup" aria-label="' + esc(L('packs_label')) + '">' + packHTML + '</div>' +
        '<label class="as-check"><input type="checkbox" id="asWaiver"><span>' + L('waiver') + ' <a href="' + esc(loc(TERMS_HREF)) + '" target="_blank" rel="noopener">' + L('waiver_terms') + '</a></span></label><button type="button" class="as-btn as-primary as-block" id="asPay" disabled>' + L('pay') + '</button><p class="as-fine">' + L('cd_fine') + '</p><p class="as-fine">' + L('cd_device') + '</p><p class="as-fine"><button type="button" class="as-link" id="asLost">' + L('recover_link') + '</button></p>'
        : '<p class="as-note">' + L('cd_soon') + '</p>'), '', 'credits');
    withCosts(function () { var el = $('#asCosts'); if (el && S.view === 'credits') el.innerHTML = costRows(); });
    if (!packs.length) return;
    var upd = function () {
      var sel = $('input[name=asPack]:checked'); $('#asPay').textContent = L('pay_amount', { price: money.format(+sel.dataset.price / 100) }); $('#asPay').disabled = !$('#asWaiver').checked;
    };
    $$('input[name=asPack]').forEach(function (n) { n.addEventListener('change', upd); }); $('#asWaiver').addEventListener('change', upd); upd();
    $('#asLost').onclick = function () { recoverSheet(function () { creditsSheet(after, reason); }); };
    var buy = function (variant, shown) {
      api('/v1/credits/cart', { auth: true, body: { waiver: true, label: shown, lang: LOCALE } }).then(function (r) {
        if (r.status !== 200) throw new Error(r.data.error);
        // record of the waiver on the order: the visible line in the customer's language (date in the page locale) is what the
        // confirmation email shows; the private _waiver_at is this browser's clock, kept for display (the proof is the service's)
        var now = new Date(), when;
        try { when = now.toLocaleString(LOCALE); } catch (e) { when = now.toISOString(); }
        var props = { _atelier_account: r.data.property, _waiver_at: now.toISOString() };
        props[L('waiver_prop')] = L('waiver_line', { date: when });
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: props }] }) });
      }).then(function (res) { if (!res.ok) throw new Error('cart'); window.location.href = '/checkout'; })
        .catch(function () { if ($('#asPay')) $('#asPay').disabled = false; else creditsSheet(after, reason); toast(L('err')); });
    };
    $('#asPay').onclick = function () {
      var btn = $('#asPay'); btn.disabled = true;
      if (!$('#asWaiver').checked) { btn.disabled = false; return; }        // the service refuses a purchase without the waiver as well
      var variant = +$('input[name=asPack]:checked').value;
      // the service records the moment itself (that is the proof); it also keeps the exact wording the page showed beside the box
      var shown = $('#asWaiver').closest('label').textContent.replace(/\s+/g, ' ').trim();
      // no email yet: the gate first, then the purchase goes on with the pack and the box the customer already chose
      if (!S.quota || !S.quota.email) return emailGate(function () { buy(variant, shown); }, 'credits');
      buy(variant, shown);
    };
  }

  /* ---------- lost access (storage erased, new phone): a one-time link to the account's email ---------- */
  function recoverSheet(back) {
    if (!(S.features && S.features.recover)) { contactSheet(L('recover_msg')); return; }   // the service cannot send the email yet: the support does it
    openSheet('<span class="as-eyebrow">' + L('cd_kicker') + '</span><h2>' + L('recover_title') + '</h2><p class="as-lead2">' + L('recover_lead') + '</p>' +
      '<form id="asRecForm" novalidate><div class="as-field"><label for="asRecEm">' + L('email_label') + '</label><input class="as-input" id="asRecEm" type="email" autocomplete="email" inputmode="email" autofocus value="' + esc((S.quota && S.quota.email) || '') + '"></div>' +
      '<p class="as-err" id="asRecErr" role="alert" hidden></p><button type="submit" class="as-btn as-primary as-block">' + L('recover_go') + '</button></form>', '', 'recover');
    $('#asRecForm').onsubmit = function (e) {
      e.preventDefault();
      var v = $('#asRecEm').value.trim(), err = $('#asRecErr'), btn = $('#asRecForm button');
      if (!EMAIL_RE.test(v)) { err.textContent = L('email_bad'); err.hidden = false; return; }
      btn.disabled = true;
      api('/v1/recover', { body: { email: v } }).then(function (r) {
        btn.disabled = false;
        if (r.status === 200) { $('#asRecForm').outerHTML = '<p class="as-note" role="status">' + esc(L('recover_sent')) + '</p>'; return; }
        if (r.status === 503) { contactSheet(L('recover_msg')); return; }
        err.textContent = errText(r.data.error); err.hidden = false;
      }, function () { btn.disabled = false; toast(L('err')); });
    };
  }
  // the page opened from the link: the one-time token becomes this device's account
  (function () {
    var m = /[?&]atelier_recover=([\w-]{20,80})/.exec(location.search); if (!m) return;
    try { history.replaceState(history.state, '', location.pathname + location.search.replace(/([?&])atelier_recover=[^&]*&?/, '$1').replace(/[?&]$/, '') + location.hash); } catch (e) {}
    api('/v1/recover/confirm', { body: { token: m[1] } }).then(function (r) {
      if (r.status !== 200 || !r.data.account) { toast(L('recover_bad')); return; }
      S.account = r.data.account; S.quota = r.data.quota; S.features = r.data.features || {}; setCosts(r.data); save(); renderWallet(); refreshMe();
      toast(L('recover_ok'));
    }, function () { toast(L('recover_bad')); });
  })();

  /* ---------- creation ---------- */
  function createSheet(text) {
    var pre = text != null ? text : (S.text || '');
    openSheet('<span class="as-eyebrow">' + L('cr_kicker') + '</span><h2>' + L('cr_title') + '</h2><p class="as-lead2">' + L('cr_lead') + '</p>' +
      '<div class="as-field"><label for="asWish">' + L('cr_label') + '</label><textarea class="as-input" id="asWish" rows="3" maxlength="600" autofocus placeholder="' + esc(L('cr_ph')) + '">' + esc(pre) + '</textarea></div>' +
      '<div class="as-field"><label>' + L('styles') + '</label><div class="as-chips" role="group" aria-label="' + esc(L('styles')) + '">' +
      numbered('style').map(function (s) { return '<button type="button" class="as-chip" data-as="style" aria-pressed="false">' + esc(s) + '</button>'; }).join('') + '</div></div>' +
      (S.photo ? '<p class="as-fine">' + L('cr_photo') + '</p>' : '') +
      '<div class="as-cost-row"><span class="as-cost" id="asCost"></span>' +
      '<button type="button" class="as-btn as-primary" id="asMake">' + L('cr_go') + '</button></div>', '', 'create');
    withCosts(function () {
      var el = $('#asCost');
      if (el) el.textContent = [costText('create'), S.quota && S.quota.email ? L('you_have', { n: S.quota.credits }) : ''].filter(Boolean).join(' · ');
    });
    $('#asMake').onclick = function () {
      var wish = $('#asWish').value.trim();
      if (wish.length < 6) { $('#asWish').focus(); toast(L('cr_short')); return; }
      var styles = $$('[data-as=style][aria-pressed=true]').map(function (b) { return b.textContent; });
      create(wish, styles);
    };
  }
  function create(wish, styles, parent) {
    return ensureAccount().then(function () {
      var again = function () { create(wish, styles, parent); };
      if (!S.quota || !S.quota.email) return emailGate(again, parent ? 'retouch' : 'create');
      var need = cost(parent ? 'retouch' : 'create') || 0;    // unknown cost: the service decides (402)
      if (S.quota.credits < need && !create.fresh) { create.fresh = true; return refreshMe().then(again); }
      create.fresh = false;
      if (S.quota.credits < need) return creditsSheet(again, needText(parent ? 'retouch' : 'create'));
      var body = { job_id: uuid(), wish: wish, styles: styles || [], room: S.understood, lang: CFG.lang };
      if (parent) body.creation = parent.creation;
      var img = parent ? parent.design : (S.items[0] && S.items[0].design_image);
      var crSteps = [L('cr_step_1'), L('cr_step_2'), L('cr_step_3'), L('cr_step_4')];
      return runJob('/v1/create', body, parent ? 'retouch' : 'create', parent ? L('rt_heading') : L('cr_heading'), img, parent ? crSteps.slice(1) : crSteps, parent ? 80000 : 130000, L('cr_hint'))
        .then(function (out) { finish(out, function (d) { created(d.result, wish); }, again); });
    }).catch(function () { toast(L('err')); });
  }
  function created(c, wish) {
    S.creations = [c].concat(S.creations.filter(function (x) { return x.creation !== c.creation; }));
    if (!$('#asResults').hidden) renderResults(true);
    var href = creationHref(c.creation);
    openSheet('<span class="as-eyebrow">' + L('mine') + '</span><h2>' + esc(c.title) + '</h2><p class="as-fine">' + L('quoted', { t: esc(wish) }) + '</p>' +
      '<div class="as-pair"><figure><img src="' + esc(c.design) + '" alt=""><figcaption>' + L('flat_cap') + '</figcaption></figure><figure><img src="' + esc(c.room) + '" alt=""><figcaption>' + L('room_cap') + '</figcaption></figure></div>' +
      '<form class="as-field" id="asRt" novalidate><label for="asRtIn">' + L('rt_label') + '</label><div class="as-row"><input class="as-input" id="asRtIn" maxlength="300" placeholder="' + esc(L('rt_ph')) + '">' +
      '<button type="submit" class="as-btn as-ghost">' + L('rt_go') + (cost('retouch') == null ? '' : ' · ' + costText('retouch')) + '</button></div></form>' +
      '<div class="as-actions">' + (href ? '<a class="as-btn as-primary" href="' + esc(href) + '">' + L('order_dims') + '</a>' : '') +
      '<button type="button" class="as-btn as-ghost" data-as="preview-creation">' + L('see_wall') + '</button></div>' +
      (href ? '' : '<p class="as-note">' + L('order_soon') + '</p>') + '<p class="as-fine">' + L('saved') + '</p>', 'is-mid', 'created');
    S.lastCreation = c;
    $('#asRt').onsubmit = function (e) { e.preventDefault(); var v = $('#asRtIn').value.trim(); if (!v) { $('#asRtIn').focus(); return; } create(v, [], c); };
  }

  /* ---------- quick view (designs whose page is not public yet) ---------- */
  function quickView(it) {
    var imgs = (it.images && it.images.length ? it.images : [it.room_image, it.design_image]);
    openSheet('<div class="as-quick-main"><img id="asQuickImg" src="' + esc(imgs[0]) + '" alt="' + esc(nameOf(it.title)) + '"></div>' +
      '<div class="as-quick-thumbs">' + imgs.map(function (u, i) { return '<button type="button" class="as-quick-thumb' + (i ? '' : ' is-on') + '" data-src="' + esc(u) + '" aria-label="' + esc(L('image_n', { n: i + 1 })) + '"><img src="' + esc(u) + '" alt=""></button>'; }).join('') + '</div>' +
      '<div class="as-pv-info"><h2>' + esc(nameOf(it.title)) + '</h2><span class="as-fine">' + esc(kindOf(it.title)) + ' · ' + L('price_from', { price: priceFrom(it) }) + '</span></div>' +
      '<div class="as-actions"><button type="button" class="as-btn as-primary" data-as="quick-wall">' + L('see_wall') + '</button>' +
      (it.url ? '<a class="as-btn as-ghost" href="' + esc(loc(it.url)) + '"' + (it.status === 'DRAFT' ? ' data-as="order-draft"' : '') + '>' + L('order_dims') + '</a>' : '') + '</div>' +
      (it.status === 'DRAFT' ? '<p class="as-note">' + L('draft_note') + '</p>' : ''), 'is-mid', 'quick');
    $$('.as-quick-thumb').forEach(function (b) { b.addEventListener('click', function () {
      $('#asQuickImg').src = b.dataset.src; $$('.as-quick-thumb').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    }); });
    S.quickItem = it;
  }

  /* ---------- contact ---------- */
  function contactSheet(prefill) {
    var tpl = $('#asContactTpl');
    openSheet('<span class="as-eyebrow">' + L('ct_kicker') + '</span><h2>' + L('ct_title') + '</h2><p class="as-lead2">' + L('ct_lead') + '</p><div id="asCt"></div>', '', 'contact');
    if (tpl) {
      $('#asCt').appendChild(tpl.content.cloneNode(true));
      var m = $('#asCMail'); if (m && S.quota && S.quota.email) m.value = S.quota.email;
      var body = $('#asCMsg'); if (body && typeof prefill === 'string' && prefill) body.value = prefill;
    }
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-as]'); if (!b) return;
    var act = b.dataset.as, cardEl = b.closest('.as-card');
    if (b.tagName === 'A') e.preventDefault();
    var item = cardEl ? (S.items.filter(function (x) { return x.handle === cardEl.dataset.handle; })[0] || S.creations.filter(function (x) { return x.creation === cardEl.dataset.creation; })[0]) : null;
    switch (act) {
      case 'close': closeSheet(); break;
      case 'view': cardEl.dataset.view = b.dataset.v; $$('.as-seg button', cardEl).forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); break;
      case 'preview':
        if (!item) return;
        preview(item.creation ? { creation: item.creation, title: item.title, thumb: item.design }
          : { handle: item.handle, title: nameOf(item.title), thumb: item.design_image, url: item.url });
        break;
      case 'preview-creation': if (S.lastCreation) preview({ creation: S.lastCreation.creation, title: S.lastCreation.title, thumb: S.lastCreation.design }); break;
      case 'refine': S.refine = S.refine === b.dataset.r ? null : b.dataset.r; start(false); break;
      case 'similar': if (item) { S.similar = item; S.refine = null; start(false); var rs = $('#asResults'); if (rs) rs.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' }); } break;
      case 'unsimilar': S.similar = null; start(false); break;
      case 'more': start(true); break;
      case 'retry': start(false); break;
      case 'create': createSheet(); break;
      case 'style': b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true'); break;
      case 'others': closeSheet(); var r = $('#asResults'); if (r && !r.hidden) r.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth' }); break;
      case 'usesample': sampleBlob().then(function (bl) { return setPhoto(bl, true); }).then(continueAfterPhoto).catch(function () { toast(L('err')); }); break;
      case 'contact': contactSheet(''); break;
      case 'quick': if (item) quickView(item); break;
      case 'order-draft': toast(L('draft_note')); if (item) quickView(item); break;
      case 'quick-wall': if (S.quickItem) preview({ handle: S.quickItem.handle, title: nameOf(S.quickItem.title), thumb: S.quickItem.design_image }); break;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

  /* the sentence box writes its own examples, like someone typing (stops as soon as the customer types) */
  // idea_1, idea_2… / style_1… as many as the locale has (a clone keeps fewer or adds more, no code change)
  function numbered(prefix) {
    var out = [];
    for (var i = 1; has(T, prefix + '_' + i); i++) if (T[prefix + '_' + i]) out.push(T[prefix + '_' + i]);
    return out;
  }
  function typewriter(ta) {
    var ideas = numbered('idea');
    if (!ta || REDUCED || !ideas.length) return;
    var k = 0, n = 0, back = false, wait = 0;
    var ex = function (s) { return L('type_example', { t: s }); };   // « Ex. {t} »
    var tick = function () {
      if (document.activeElement === ta || ta.value) { ta.placeholder = ex(ideas[k]); return setTimeout(tick, 600); }
      if (wait > 0) { wait--; return setTimeout(tick, 90); }
      var s = ideas[k];
      n += back ? -1 : 1;
      ta.placeholder = ex(s.slice(0, n) + (n < s.length || back ? '|' : ''));
      if (!back && n >= s.length) { back = true; wait = 22; }
      else if (back && n <= 0) { back = false; k = (k + 1) % ideas.length; wait = 4; }
      setTimeout(tick, back ? 28 : 55 + Math.random() * 45);
    };
    tick();
  }

  var form = $('#asEntry');
  if (form) {
    typewriter($('#asText'));
    form.addEventListener('submit', function (e) { e.preventDefault(); S.refine = null; S.similar = null; start(false); });
    $('#asPhoto').addEventListener('change', function (e) { var f = e.target.files[0]; e.target.value = ''; if (f) setPhoto(f).then(function () { S.refine = null; S.similar = null; start(false); }); });
    $('#asSample').addEventListener('click', function () { sampleBlob().then(function (bl) { return setPhoto(bl, true); }).then(function () { S.refine = null; S.similar = null; start(false); }).catch(function () { toast(L('err')); }); });
    $$('.as-say [data-q]').forEach(function (c) { c.addEventListener('click', function () { $('#asText').value = c.dataset.q; S.refine = null; S.similar = null; start(false); }); });
    var moreIdeas = $('#asMoreIdeas');
    if (moreIdeas) moreIdeas.addEventListener('click', function () {
      var open = moreIdeas.getAttribute('aria-expanded') !== 'true';
      moreIdeas.setAttribute('aria-expanded', open); $('#asIdeas').hidden = !open;
    });
    var z = $('#asZone');
    ['dragenter', 'dragover'].forEach(function (t) { z.addEventListener(t, function (e) { e.preventDefault(); z.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { z.addEventListener(t, function (e) { e.preventDefault(); z.classList.remove('is-over'); }); });
    z.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) setPhoto(f).then(function () { start(false); }); });
  }
  // homepage « Comment ça marche »: the real before/after slider
  $$('.as-demo-ba').forEach(function (ba) {
    var r = $('input[type=range]', ba);
    if (r) r.addEventListener('input', function () { ba.style.setProperty('--x', r.value + '%'); });
  });

  // Shopify's contact form redirects back with ?contact_posted=true: confirm, then clean the URL
  if (/[?&]contact_posted=true/.test(location.search)) {
    toast(L('contact_sent'));
    try { history.replaceState(history.state, '', location.pathname + location.search.replace(/[?&]contact_posted=true/, '').replace(/^&/, '?') + location.hash); } catch (e) {}
  }

  refreshMe();

  window.MPPAssistant = {
    preview: function (o) { return preview(o || {}); },
    create: function (text) { createSheet(text); },
    credits: function () { creditsSheet(null); },
    contact: contactSheet,
    setPhoto: setPhoto
  };
})();
